import { get, post, put } from "../utils/request";

/* 存储请求地址*/
export const requestUrl = {
  /*入库管理*/
  /*原材料入库 */
  treeMenu:'/uaa/menu/tree',
  WarehouseType:"/xxy/basic/warehouse/listLocationNoByWarehouseType",
  wareHouseList:'/xxy/basic/warehouseType/list',
  getMaster: "/xxy/basic/material/list",
  getSupplier: "/xxy/basic/supplier/listAll", //供应商下拉接口
  getClient: "/xxy/basic/client/listAll",
  getWarehouse: "/xxy/basic/warehouse/listLocationNo",
  rawMaterialStockList: "/xxy/warehouse/rawMaterialStock/list",
  saveRawMaterialStock: "/xxy/warehouse/rawMaterialStockRecord/save",
  getRawMaterialStockDetailList: "/xxy/warehouse/rawMaterialStockRecord/list",
  /*成品入库 */
  finishedProductStockList: "/xxy/warehouse/finishedProductStockRecord/list",
  saveFinishedProductStock: "/xxy/warehouse/finishedProductStockRecord/save",
  getScanCodeDetail: "/xxy/warehouse/finishedProductStockRecord/scanCode",
  getListWithGroup:'/xxy/warehouse/finishedProductStockRecord/listWithGroup', //产品入库列表
  /*退货入库 */
  returnsStockList: "/xxy/warehouse/returnStockRecord/list",
  saveReturnsStock: "/xxy/warehouse/returnStockRecord/save",
  getReturnsScanCodeDetail: "/xxy/warehouse/returnStockRecord/scanCode",
  getByCodeByPlanNo:"/xxy/warehouse/returnStockRecord/getByCodeByPlanNo", //调用生产计划号的接口
  /*成品转原材料 */
  productChangeList: "/xxy/warehouse/productChange/list",
  saveProductChange: "/xxy/warehouse/productChange/save",
  /*配货列表*/
 orderOutStock:"/xxy/warehouse/orderOutStock/listWithGroup", //配货列表的页面
 listDistributionDetail:'/xxy/warehouse/orderOutStock/listDistributionDetail', // 配货列表详情的接口

 /** 发货明细列表 */
ShipmentDetails:'/xxy/warehouse/orderOutStock/listDistributionDetail', 
  /*出库管理*/
  /*生产领料 */
  getBomList:'/xxy/product/plan/getBomList',  //生产领料的列表接口
  getBomByPlanNo: "/xxy/product/plan/getBomByPlanNo", //根据计划生产号获取物料bom
  producePickingList: "/xxy/warehouse/productUse/list",
  saveProducePicking: "/xxy/warehouse/productUse/save",
  rawMaterialStockListAll: "/xxy/warehouse/rawMaterialStockRecord/listAll", //根据物料ids获取原材料库存记录
  saveProduceSaveByMerge:"/xxy/warehouse/productUse/saveByMerge",
  getListOutPlan:'/xxy/warehouse/orderOutStock/listOutPlan', //销售发货列表明细
  EditByBatch:'/xxy/warehouse/finishedProductStockRecord/editByBatch', //移库提交的接口
  saveOrUpdateBatchOrderDistribution:'/xxy/warehouse/orderOutStock/saveOrUpdateBatchOrderDistribution', //确定提交的接口

  /*原材料出库*/
  saveRawMaterialsOutStockRecord: "/xxy/warehouse/rawMaterialsOutStockRecord/save",
  rawMaterialsOutStockRecordList: "/xxy/warehouse/rawMaterialsOutStockRecord/list",

  /*销出 */
  listOutOrder: "/xxy/warehouse/orderOutStock/listOutOrder", //根据订单号查询出库订单信息
  orderStockList: "/xxy/warehouse/orderOutStock/list",
  saveOrderStock: "/xxy/warehouse/orderOutStock/save",
  finishedProductStockListAll:
    "/xxy/warehouse/finishedProductStockRecord/listAll", //根据物料ids获取成品库存记录
  getSalesOutPrintData: "/xxy/warehouse/orderOutStock/getPrint", //根据ids获取出库单打印信息

  /*包装条码 */
  //  packageCodeList: "/xxy/warehouse/packageCode/list", 
  packageCodeList: "/xxy/warehouse/packageCode/listWithGroup", //包装条码的列表接口
  generateCode: "/xxy/warehouse/packageCode/generateCode",
  print: "/xxy/warehouse/packageCode/print",
  PackageBarcodeDetails:'/xxy/warehouse/packageCode/list', //包装条码详情的接口
  /*原材料库存报表 */
   MaterReportList:'/xxy/report/rawMaterialsStockReport/list',
   MaterReportDetail:'/xxy/report/rawMaterialsStockReportRecord/list', //库存明细的Table列表
  /*库存报表 */
  stockReportList: "/xxy/warehouse/rawMaterialStock/list",
  /*库存报表2 */
  stockReportList2: "/xxy/warehouse/finishedProductStockRecord/listReportVO",
  stockReportDetail2:
    "/xxy/warehouse/finishedProductStockRecord/listReportDetail"
};

/* 测试接口的数据 */
export async function getRequest(url, data, options) {
  return await get(url, data, options);
}

/* 测试接口的数据 */
export async function postRequest(url, data, options) {
  return await post(url, data, options);
}
/* 测试接口的数据 */
export async function putRequest(url, data, options) {
  return await put(url, data, options);
}
